// engine
import { ArContainer, screenDispatcher, gameDispatcher, ArSpine, ORIENTATION } from '@aceroll/core';

// constants
import { GAME_VIEW } from '../constants/game';

const ANIMATION = {
    IDLE: 'idle',
    EXPRESSIVE: 'expressive',
    ACTION: 'action'
};

export class Background extends ArContainer {
    #spine = null;
    #animations = {
        [ORIENTATION.LANDSCAPE]: {
            [GAME_VIEW.MAIN]: {
                [ANIMATION.IDLE]: 'idle_day_L',
                [ANIMATION.EXPRESSIVE]: 'idle_day_1_L',
                [ANIMATION.ACTION]: 'action_day_L'
            },
            [GAME_VIEW.BONUS]: {
                [ANIMATION.IDLE]: 'idle_night_L',
                [ANIMATION.EXPRESSIVE]: 'idle_night_1_L'
            }
        },
        [ORIENTATION.PORTRAIT]: {
            [GAME_VIEW.MAIN]: {
                [ANIMATION.IDLE]: 'idle_day_P',
                [ANIMATION.EXPRESSIVE]: 'idle_day_1_P',
                [ANIMATION.ACTION]: 'action_day_P'
            },
            [GAME_VIEW.BONUS]: {
                [ANIMATION.IDLE]: 'idle_night_P',
                [ANIMATION.EXPRESSIVE]: 'idle_night_1_P'
            }
        }
    };

    #initial = true;
    #idleCounter = 0;

    constructor() {
        super('background-container');

        this.onSpineRepeat = this.onSpineRepeat.bind(this);

        this.#setup();
    }

    #setup() {
       this.#setupSpine();
    }

    #setupSpine() {
        this.#spine = new ArSpine('spine-background');
        this.#spine.addEvent('repeat', this.onSpineRepeat);
        this.addChild(this.#spine);
    }

    onLandscape() {
        this.#spine.position.set(1024, 472);

        if (this.#initial) {
            this.playExpressive();
            this.#initial = false;
            return;
        }

        this.playIdle();
    }

    onPortrait() {
        this.#spine.position.set(472, 1024);
        
        if (this.#initial) {
            this.playExpressive();
            this.#initial = false;
            return;
        }

        this.playIdle();
    }

    setMainView() {
        this.playIdle();
    }

    setBonusView() {
        this.playExpressive();
    }

    playIdle() {
        const { orientation } = screenDispatcher.state;
        const { gameView } = gameDispatcher.state;

        const idle = this.#animations[orientation][gameView][ANIMATION.IDLE];

        this.#spine.stop(true);

        this.resetIdleCounter();

        return this.#spine.setImmediately(idle, true);
    }

    playExpressive() {
        const { orientation } = screenDispatcher.state;
        const { gameView } = gameDispatcher.state;

        const expressive = this.#animations[orientation][gameView][ANIMATION.EXPRESSIVE];
        const idle = this.#animations[orientation][gameView][ANIMATION.IDLE];

        this.#spine.stop(true);

        this.resetIdleCounter();

        return this.#spine.setImmediately([expressive, idle], true);
    }

    playAction() {
        const { orientation } = screenDispatcher.state;
        const { gameView } = gameDispatcher.state;

        if (gameView === GAME_VIEW.BONUS) {
            return;
        }

        const action = this.#animations[orientation][gameView][ANIMATION.ACTION];
        const idle = this.#animations[orientation][gameView][ANIMATION.IDLE];

        this.#spine.stop(true);

        this.resetIdleCounter();

        return this.#spine.setImmediately([action, idle], true);
    }

    resetIdleCounter() {
        this.#idleCounter = 0;
    }

    onSpineRepeat() {
        this.#idleCounter += 1;

        if (this.#idleCounter >= 3) {
            this.playExpressive();
        }
    }
}